import has from 'lodash/has';

type PaginationFilterType = {
  page: number;
  pageSize: number;
};

export const PAGINATION_STORAGE_KEY = 'facility-grid-pagination-model';
const getSessionPaginationFilters = () => {
  try {
    const storedFilters = sessionStorage.getItem(PAGINATION_STORAGE_KEY);
    return JSON.parse(storedFilters || '{}');
  } catch (e) {
    return {};
  }
};

export const buildPaginationFiltersFactory = (config: {
  loadDefault?: boolean;
  fromSession?: boolean;
}) => {
  const sessionParams: PaginationFilterType = getSessionPaginationFilters();
  const acc: PaginationFilterType = {
    page: 0,
    pageSize: 25,
  };

  const addFilter = (
    filterKey: keyof PaginationFilterType,
    defaultValue: number,
    valueParser: (v: string) => any
  ) => {
    if (config.loadDefault) {
      acc[filterKey] = defaultValue;
    } else if (config.fromSession && has(sessionParams, filterKey)) {
      acc[filterKey] = valueParser(sessionParams[filterKey] as any);
    }
  };

  const factory = {
    addNumberFilter(
      filterKey: keyof PaginationFilterType,
      defaultValue: number
    ) {
      addFilter(filterKey, defaultValue, (v) => +v || defaultValue);
      return factory;
    },
    build() {
      return acc;
    },
  };

  return factory;
};
